import React from "react";
import "./style.scss";

export default function Bubble(props) {
  return (
    <div className="speech-bubble">
      <strong>{props.name},</strong>
      <span>{` como empleado del Banco Patagonia, tenés esta opción bonificada`}</span>
    </div>
  );
}
